
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <Card>
          <CardHeader>
            <CardTitle className="text-2xl">Termos de Serviço</CardTitle>
            <p className="text-sm text-gray-600">Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>
          </CardHeader>
          <CardContent className="space-y-6">
            <section>
              <h2 className="text-xl font-semibold mb-3">1. Aceitação dos Termos</h2>
              <p className="text-gray-700 leading-relaxed">
                Ao usar nosso serviço, você concorda em ficar vinculado a estes termos de serviço 
                e a todas as leis e regulamentos aplicáveis.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">2. Descrição do Serviço</h2>
              <p className="text-gray-700 leading-relaxed">
                Nosso serviço permite que você gerencie e publique conteúdo em suas redes sociais, 
                incluindo Instagram e Facebook, através de nossa plataforma.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">3. Conta do Usuário</h2>
              <p className="text-gray-700 leading-relaxed">
                Você é responsável por manter a confidencialidade de sua conta e senha, 
                e por todas as atividades que ocorrem sob sua conta.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">4. Uso Aceitável</h2>
              <p className="text-gray-700 leading-relaxed">
                Você concorda em usar nosso serviço apenas para fins legais e de acordo com:
              </p>
              <ul className="list-disc list-inside text-gray-700 mt-2 space-y-1">
                <li>Estes termos de serviço</li>
                <li>Todas as leis e regulamentos aplicáveis</li>
                <li>Os termos de serviço das plataformas de redes sociais conectadas</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">5. Conteúdo do Usuário</h2>
              <p className="text-gray-700 leading-relaxed">
                Você mantém a propriedade de todo o conteúdo que publica através de nosso serviço. 
                Você é responsável por garantir que seu conteúdo não viole direitos de terceiros.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">6. Limitações de Responsabilidade</h2>
              <p className="text-gray-700 leading-relaxed">
                Nosso serviço é fornecido "como está" e não garantimos operação ininterrupta 
                ou livre de erros. Não seremos responsáveis por danos indiretos ou consequenciais.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">7. Modificações dos Termos</h2>
              <p className="text-gray-700 leading-relaxed">
                Reservamo-nos o direito de modificar estes termos a qualquer momento. 
                As modificações entrarão em vigor imediatamente após a publicação.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">8. Contato</h2>
              <p className="text-gray-700 leading-relaxed">
                Para questões sobre estes termos, entre em contato:
                <br />
                Email: colombesalexanderferreira@gmail.com
                <br />
                Website: minhagencia.digital
              </p>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default TermsOfService;
